import http from '../utils/http';
import axios from 'axios';
import i18n from '@/main';

const baseRoute = '/operacao';

export default {
    aprovar(id, body) {
        return http.post({
            url: baseRoute + `/${id}/aprovar`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.aprovandoOperacao')
        });
    },

    atualizarStatus(body) {
        return http.post({
            url: baseRoute + '/alterar-status',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoStatusOperacao')
        });
    },

    buscar(textoBusca, statusBusca, paginacao, alerta = false) {
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseRoute +
            '?texto-busca=' +
            textoBusca +
            '&pagina=' +
            pagina +
            '&alertas=' +
            alerta;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        if (statusBusca.length > 0) {
            url += '&status=' + statusBusca;
        }

        return http.get({
            url: url,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoes')
        });
    },

    buscarPapeisPessoa() {
        return http.get({
            url: baseRoute + '/papeis-pessoa',
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoListaDePapeisDePessoa'
            )
        });
    },

    buscarMotivosReprovacao() {
        return http.get({
            url: baseRoute + '/motivos-reprovacao',
            lockScreen: false
        });
    },

    buscarDadosMonitoramento(idOperacao) {
        return http.get({
            url: baseRoute + `/${idOperacao}/monitoramento`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosDeMonitoramento'
            )
        });
    },

    buscarDadosAnaliseTerritorio(idTerritorio) {
        return http.get({
            url: baseRoute + `/monitoramento/territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosDeAnaliseDoTerritorio'
            )
        });
    },

    buscarDadosAnalisePessoa(idPessoa) {
        return http.get({
            url: baseRoute + `/monitoramento/pessoa/${idPessoa}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDadosDeAnaliseDaPessoa'
            )
        });
    },

    buscarStatusFiltro() {
        return http.get({
            url: baseRoute + '/status',
            lockScreen: false
        });
    },

    buscarCategorias(protocolo) {
        if (!protocolo) {
            return Promise.reject(
                new Error('Protocolo é obrigatório para buscar categorias')
            );
        }
        return http.get({
            url: baseRoute + `/categorias?protocolo=${protocolo}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoListaDeCategorias')
        });
    },

    buscarProdutos(tipo) {
        return http.get({
            url: baseRoute + `/produtos?tipo=${tipo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoProdutos')
        });
    },

    inserir(body) {
        return http.post({
            url: baseRoute + '/inserir',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.inserindoOperacao')
        });
    },

    buscarPorId(id) {
        return http.get({
            url: baseRoute + `/${id}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDaOperacao')
        });
    },

    editar(body, idOperacao) {
        return http.put({
            url: baseRoute + `/${idOperacao}/editar`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoOperacao')
        });
    },

    buscarTipoGleba() {
        return http.get({
            url: baseRoute + '/tipos/gleba',
            lockScreen: false
        });
    },

    buscarGlebasPorIdTerritorio(idTerritorio, filtro) {
        return http.get({
            url: baseRoute + `/gleba/${idTerritorio}?filtro=${filtro}`,
            lockScreen: false
        });
    },

    baixarCoordenadasExcel(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/coordenadas-excel`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    baixarCoordenadasExcelBndes(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/coordenadas-excel-bndes`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    baixarCoordenadasCsv(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/coordenadas-csv`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    reprovar(id, body) {
        return http.post({
            url: baseRoute + `/${id}/reprovar`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.reprovandoOperacao')
        });
    },

    validarSobreposicaoGlebas(body) {
        return http.post({
            url: baseRoute + `/gleba/validar-sobreposicao`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.validandoFinanciamentoDeGlebas'
            )
        });
    },

    exportarAnalise(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/exportar-analise`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.exportandoAnaliseSocioambiental'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    downloadPdfAprovacao(idAnalise) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/analise/${idAnalise}/download-pdf`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.realizandoDownloadDaAnaliseSocioambiental'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    validarPlanilhaCancelamento(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            '/operacao/validar-planilha-cancelamento';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    downloadPlanilhaErroCancelamento(arquivoHash) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url:
                        baseRoute +
                        `/${arquivoHash}/download-planilha-cancelamento`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    processarPlanilhaCancelamento(arquivoHash) {
        return http.post({
            url: baseRoute + `/${arquivoHash}/processar-planilha-cancelamento`,
            data: null,
            lockScreen: true
        });
    },

    enviarPlanilhaOperacaoEmLote(tipoPlanilha, planilha) {
        const url = process.env.VUE_APP_HTTP_PATH + baseRoute + `/planilha-lote/${tipoPlanilha}/upload`;

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    listarPlanilhasOperacaoEmLote(tipoPlanilha, { page, size }) {
        return http.get({
            url: baseRoute + `/planilha-lote/${tipoPlanilha}/listar?page=${page}&size=${size}`,
            lockScreen: false,
            data: null
        });
    },

    downloadPlanilhaOperacaoEmLote(id, tipoArquivo) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/planilha-lote/${id}/${tipoArquivo}/download`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'planilha.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    downloadTemplatePlanilhaOperacaoEmLote(tipoPlanilha) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/planilha-lote/${tipoPlanilha}/template`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'template.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute('download', filename);
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    preAnaliseAptidaoFinanciamento(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-aptidao',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    detalheAnaliseAptidao(payload) {
        return http.post({
            url: baseRoute + '/detalhe-analise-aptidao',
            lockScreen: true,
            data: payload
        });
    },

    preAnaliseDuplicidade(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-duplicidade',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    preAnaliseResumo(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-resumo',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    preAnaliseTerritorio(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-territorio',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    preAnaliseGleba(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-gleba',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    preAnalisePessoa(payload) {
        return http.post({
            url: baseRoute + '/pre-analise-pessoa',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    verificarTerritorio(idTerritorio) {
        return http.get({
            url: baseRoute + `/verificar-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.operacao.notificacao.verificandoOperacoesTerritorio'
            )
        });
    },

    listarHistorico(idOperacao) {
        return http.get({
            url: baseRoute + `/listar-historico/${idOperacao}`,
            lockScreen: true,
            data: null
        });
    },

    listarPlanilhaCadastroOperacaoEmLote({page, size}) {
        return http.get({
            url: baseRoute + `/listar-planilhas-cadastro-lote/?page=${page}&size=${size}`,
            lockScreen: false,
            lockMessage: i18n.t(
                'mensagens.operacoesLote.buscandoLista'
            ),
            data: null
        });
    },

    downloadPlanilhaCadastroEmLote(id, tipo) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/${tipo}/download-planilha-cadastro-lote`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        let filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';
                        const contentDisposition = response.headers['content-disposition'];

                        if (contentDisposition) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(contentDisposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                            }
                        }

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    validarPlanilhaCadastroEmLote(planilha) {
        const url = process.env.VUE_APP_HTTP_PATH + baseRoute + '/validar-planilha-cadastro-lote';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    downloadTemplateCadastroEmLote() {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + '/download-template-cadastro-lote',
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        // Nome fixo do template
                        const filename = 'Modelo_Cadastro_Operacoes_Lote.xlsx';

                        fileLink.setAttribute(
                            'download',
                            filename
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    listarDetalhesCadastroLote(id) {
        return http.get({
            url: baseRoute + `/cadastro-lote/${id}/detalhes`,
            lockScreen: true
        });
    },

    verificarDeslocamentoGleba(payload) {
        return http.post({
            url: baseRoute + '/gleba/verificar-deslocamento',
            data: payload,
            lockScreen: true
        });
    }
};
